exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tooltip{left:50%;margin-top:10px;position:absolute;top:100%;transform:translateX(-50%);z-index:2}.tooltip-body{background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 3px rgba(0,0,0,.24);margin-bottom:20px;padding:18px;background-color:#fff;border-radius:3px;box-shadow:0 1px 6px #888;color:#fff;margin-top:-4px;padding:3px 8px;text-align:left}.tooltip-body header{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.8rem;margin-bottom:10px}.tooltip-body li{list-style:none;margin:10px;white-space:nowrap}.cf .tooltip-body a,.hitachi .tooltip-body a{text-decoration:none}.caret .tooltip{left:auto;margin-top:23px;right:0;transform:none}.caret-icon .tooltip{left:auto;right:-12px;transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/popover/tooltip.scss
// module id = 5276
// module chunks = 0